module.exports = __webpack_public_path__ + "static/media/background-dots.8b3be467.svg";